import React from "react";
import PropTypes from "prop-types";
import AvatarEditor from "react-avatar-editor";
import Dropzone from "react-dropzone";
// Material imports
import makeStyles from "@mui/styles/makeStyles";
import Typography from "@mui/material/Typography";
import Slider from "@mui/material/Slider";
//Limitless imports
import { withi18n } from "../../../customer/components";
const AddPicture = ({
  t,
  avatarEditorRef
}) => {
  const classes = useStyles();
  const [localState, setLocalState] = React.useState({
    image: null,
    hasImage: false,
    zoomValue: 1,
    picture: null,
    isSaved: false
  });
  const {
    image,
    hasImage,
    zoomValue,
    isSaved
  } = localState;
  const handleImageDrop = acceptedFiles => {
    if (acceptedFiles[0]) {
      setLocalState({
        ...localState,
        image: acceptedFiles[0],
        hasImage: true
      });
    }
  };
  const handleZoomChange = (event, value) => {
    setLocalState({
      ...localState,
      zoomValue: value
    });
  };
  const getAvatarEditor = () => {
    return /*#__PURE__*/React.createElement(Dropzone, {
      onDrop: handleImageDrop,
      disableClick: hasImage,
      className: classes.dropZone,
      style: {
        height: 201,
        width: 220,
        margin: 16
      },
      accept: "image/*"
    }, !hasImage ? /*#__PURE__*/React.createElement(Typography, {
      align: "center",
      variant: "caption",
      className: classes.placeholderText
    }, t("Click to select a file or drag a file from your desktop")) : /*#__PURE__*/React.createElement(AvatarEditor, {
      ref: avatarEditorRef,
      image: image,
      width: 1500,
      height: 1500,
      border: 50,
      color: [170, 170, 170, 0.7] // RGBA
      ,
      scale: zoomValue,
      borderRadius: 750,
      style: {
        height: 203,
        width: 222,
        borderRadius: "6px"
      }
    }));
  };
  return /*#__PURE__*/React.createElement("div", null, getAvatarEditor(), /*#__PURE__*/React.createElement("div", null, /*#__PURE__*/React.createElement(Slider, {
    value: zoomValue,
    onChange: handleZoomChange,
    min: 1,
    max: 2,
    disabled: !hasImage || isSaved,
    marks: true,
    step: 0.1,
    sx: {
      color: theme => theme.palette.primary.light
    }
  })));
};
const useStyles = makeStyles(theme => ({
  placeholderText: {
    width: 200
  },
  dropZone: {
    margin: 20,
    width: "unset",
    height: "unset",
    borderStyle: "solid",
    borderRadius: 10,
    borderColor: `${theme.palette.secondary.contrastText}10`,
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    "&:hover": {
      cursor: "pointer",
      borderStyle: "dashed"
    }
  }
}));
export default withi18n(AddPicture);
AddPicture.propTypes = {
  avatarEditorRef: PropTypes.object.isRequired,
  t: PropTypes.func.isRequired
};